import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { BootstrapVue } from 'bootstrap-vue';
//import { createProvider } from './vue-apollo'
import { ethers } from 'ethers';
import vSelect from "vue-select";
import VueToast from 'vue-toast-notification';
import './directives'
import "vue-select/dist/vue-select.css";
import './assets/scss/index.scss';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.filter('toEth', val => val && ethers.utils.formatUnits(ethers.utils.bigNumberify(val), 6));

Vue.filter('toEth18', val => val && ethers.utils.formatUnits(ethers.utils.bigNumberify(val), 18));

Vue.filter('toTokens', val => val && ethers.utils.formatUnits(ethers.utils.bigNumberify(val), 6));

Vue.filter('to4dp', val => val && parseFloat(val).toFixed(4));

Vue.filter('formatNum', val => {
    if(val || val >= 0 || val <= 0){
        let str = val + "";
        if (str.endsWith('.000000')) {
            return str.replace('.000000', '');
        } else if (str.endsWith('.00000')) {
            return str.replace('.00000', '');
        } else if (str.endsWith('.0000')) {
            return str.replace('.0000', '');
        } else if (str.endsWith('.000')) {
            return str.replace('.000', '');
        } else if (str.endsWith('.00')) {
            return str.replace('.00', '');
        } else if (str.endsWith('.0')) {
            return str.replace('.0', '');
        } else {
            return val
        }
    }else{
        return val
    }
});

Vue.filter('toShortAccount', val => val && val.substr(0, 6) + '...' + val.substr(val.length - 6, val.length));

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(VueToast);

Vue.config.productionTip = false;

import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";

const client = new ApolloClient({
    uri: "https://api.thegraph.com/subgraphs/name/shivam3012/stableswitch"
});

const apolloProvider = new VueApollo({
    defaultClient: client,
});

Vue.use(VueApollo);
Vue.component("v-select", vSelect);

import VueCurrencyFilter from 'vue-currency-filter';

Vue.use(VueCurrencyFilter, [
    {
        symbol: '',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: false
    },
    {
        name: 'dollars',
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: false
    }
]);

new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
